// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_apiKey,
//   authDomain: process.env.REACT_APP_authDomain,
//   projectId: process.env.REACT_APP_projectId,
//   storageBucket: process.env.REACT_APP_storageBucket,
//   messagingSenderId: process.env.REACT_APP_messagingSenderId,
//   appId: process.env.REACT_APP_appId,
// };
const firebaseConfig = {
  apiKey: "AIzaSyCcJqDPICENZ7QnskXmwStUwY2Ji4lSr_Y",
  authDomain: "onlineitghor.firebaseapp.com",
  projectId: "onlineitghor",
  storageBucket: "onlineitghor.appspot.com",
  messagingSenderId: "660144656056",
  appId: "1:660144656056:web:f103ff187495fea76eee4d",
};

console.log(
  process.env.REACT_APP_apiKey,
  process.env.REACT_APP_authDomain,
  process.env.REACT_APP_projectId,
  process.env.REACT_APP_storageBucket,
  process.env.REACT_APP_messagingSenderId,
  process.env.REACT_APP_appId
);


// Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app